import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PayrollService } from 'app/services/models/payroll.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss']
})
export class PayrollComponent implements OnInit {
  @Input() data: { personId: number; row: any };
  payrollForm: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private payrollService: PayrollService,
    private fb: FormBuilder,
    private toastrService: ToastrService) { }

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  ngOnInit(): void {
    this.payrollForm = this.fb.group({
      grossSalary: [0, [Validators.required]],
      interruption: [0, [Validators.required]],
      netSalary: [0, [Validators.required]],
      supplementaryPayment: [0, [Validators.required]],
      totalPayment: [0, [Validators.required]],
      periodDate: [null, [Validators.required]],
      personId: this.data.personId
    });
    console.log(this.data.row)
    if (this.data.row) {
      this.payrollForm.patchValue({
        grossSalary: this.data.row.grossSalary,
        interruption: this.data.row.interruption,
        netSalary: this.data.row.netSalary,
        supplementaryPayment: this.data.row.supplementaryPayment,
        totalPayment: this.data.row.totalPayment,
        periodDate: this.data.row.periodDate,
        personId: this.data.personId
      })
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if(this.payrollForm.valid){
      console.log(this.payrollForm.value);
      if(this.data.row){
        const response = await this.payrollService.updatePayroll(this.data.row.id,this.payrollForm.value);
        if(response.status == true){
          this.payrollService.sendEvent(true);
          this.closeModal();
          this.toastrService.success(response.message);
        }else{
          this.toastrService.error(response.message);
        }
      }else{
        const response = await this.payrollService.createPayroll(this.payrollForm.value)
        if(response.status == true){
          this.payrollService.sendEvent(true);
          this.closeModal();
          this.toastrService.success(response.message);
        }else{
          this.toastrService.error(response.message);
        }
      }
    }
  }
}
